var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": _vm.accountType === 'MOBILE' ? $t("allzi75", "绑定手机号") : $t("gdxzzg4", "绑定邮箱"),
      "mask-closable": false,
      "width": "500"
    },
    on: {
      "on-cancel": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "bind-message"
  }, [_c('Alert', {
    attrs: {
      "type": "success",
      "show-icon": "",
      "closable": ""
    }
  }, [_vm._v(_vm._s(_vm.accountType === "MOBILE" ? $t("p6djkpk", "绑定手机号后，可用该手机号登录iWork") : $t("tb1cxni", "绑定邮箱后，可用该邮箱登录iWork")))]), _c('SendMessage', {
    ref: "sendMessage",
    attrs: {
      "accountType": _vm.accountType,
      "showText": !_vm.uuid,
      "mode": "REGISTER"
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1) : _vm._e(), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v($t("frw3tr4", "确认绑定"))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };